export default __webpack_public_path__ + "static/media/neirong.3fc2bb84.png";